import React from 'react';
import { TrendingUp, AlertTriangle, Package, Lightbulb, TrendingDown, CheckCircle } from 'lucide-react';

const TYPE_STYLE = {
  slow_moving: { icon: TrendingDown, bg: 'bg-amber-50', border: 'border-amber-200', text: 'text-amber-700' },
  restock:     { icon: Package,      bg: 'bg-blue-50',  border: 'border-blue-200',  text: 'text-blue-700' },
  expiring:    { icon: AlertTriangle,bg: 'bg-red-50',   border: 'border-red-200',   text: 'text-red-700' },
  success:     { icon: CheckCircle,  bg: 'bg-emerald-50', border: 'border-emerald-200', text: 'text-emerald-700' },
  revenue:     { icon: TrendingUp,   bg: 'bg-violet-50', border: 'border-violet-200', text: 'text-violet-700' },
  tip:         { icon: Lightbulb,    bg: 'bg-yellow-50', border: 'border-yellow-200', text: 'text-yellow-700' },
};

const AIInsightsStrip = ({ insights }) => {
  if (!insights || insights.length === 0) return null;

  return (
    <div>
      <p className="text-xs text-muted-foreground mb-3 font-medium uppercase tracking-wide">AI Insights</p>
      <div className="flex gap-3 overflow-x-auto pb-2">
        {insights.map((insight, idx) => {
          const style = TYPE_STYLE[insight.type] || TYPE_STYLE.tip;
          const Icon = style.icon;
          return (
            <div
              key={idx}
              className={`flex-shrink-0 w-64 rounded-xl border p-4 ${style.bg} ${style.border}`}
            >
              <div className="flex items-start gap-2">
                <Icon className={`h-4 w-4 mt-0.5 flex-shrink-0 ${style.text}`} />
                <div>
                  <p className={`text-xs font-semibold ${style.text}`}>{insight.title}</p>
                  <p className="text-xs text-foreground/70 mt-1 leading-relaxed">{insight.message}</p>
                  {insight.action && (
                    <p className="text-xs font-medium mt-2 text-foreground/60">{insight.action}</p>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AIInsightsStrip;
